
import { create } from "@mui/material/styles/createTransitions";

export const BASE_URL = 'https://devqsoftbe.onrender.com/api/';
// export const SOCKET_URL = 'http://192.168.29.50:8000';



export const API_END_POINTS =  {


  
  // ================= ADMIN AUTH =================

  adminSendSignup: {
    END_POINT: 'admin/signup',
    TYPE: 'POST',
    KEY: 'adminSendSignup',
  },

  adminSendLogin: {
    END_POINT: 'admin/login',
    TYPE: 'POST',
    KEY: 'adminSendLogin',
  },

  adminVerifyOtp: {
    END_POINT: 'admin/verify-otp',
    TYPE: 'POST',
    KEY: 'adminVerifyOtp',
  },

  adminLogout: {
    END_POINT: 'admin/logout',
    TYPE: 'POST',
    KEY: 'adminLogout',
  },

  adminRefreshToken: {
    END_POINT: 'admin/refresh-token',
    TYPE: 'POST',
    KEY: 'adminRefreshToken',
  },


  // ================= SUBJECT =================

  createSubject: {
    END_POINT: 'admin/subjects',
    TYPE: 'POST',
    KEY: 'createSubject',
  },

  updateSubject: {
    END_POINT: 'admin/subjects/:id',
    TYPE: 'PUT',
    KEY: 'updateSubject',
  },

  deleteSubject: {
    END_POINT: 'admin/subjects/:id',
    TYPE: 'DELETE',
    KEY: 'deleteSubject',
  },

  getAllSubjects: {
    END_POINT: 'user/subjects',
    TYPE: 'GET',
    KEY: 'getAllSubjects',
  },

  // getSubjectById: {
  //   END_POINT: 'user/subjects/:id',
  //   TYPE: 'GET',
  //   KEY: 'getSubjectById',
  // },
  getTopicsBySubjectId : {
    END_POINT: 'user/subjects/:id/topics',
    TYPE: 'GET',
    KEY: 'getTopicsBySubjectId',
  },


  // ================= TOPIC =================

  createTopic: {
    END_POINT: 'admin/topics',
    TYPE: 'POST',
    KEY: 'createTopic',
  },

  updateTopic: {
    END_POINT: 'admin/topics/:id',
    TYPE: 'PUT',
    KEY: 'updateTopic',
  },

  deleteTopic: {
    END_POINT: 'admin/topics/:id',
    TYPE: 'DELETE',
    KEY: 'deleteTopic',
  },

  getAllTopics: {
    END_POINT: 'user/topics',
    TYPE: 'GET',
    KEY: 'getAllTopics',
  },

  getTopicById: {
    END_POINT: 'user/topics/:id',
    TYPE: 'GET',
    KEY: 'getTopicById',
  },


  // ================= CONTENT =================

  createContent: {
    END_POINT: 'admin/content',
    TYPE: 'POST',
    KEY: 'createContent',
  },

  updateContent: {
    END_POINT: 'admin/content/:id',
    TYPE: 'PUT',
    KEY: 'updateContent',
  },

  deleteContent: {
    END_POINT: 'admin/content/:id',
    TYPE: 'DELETE',
    KEY: 'deleteContent',
  },

  getAllContent: {
    END_POINT: 'user/content',
    TYPE: 'GET',
    KEY: 'getAllContent',
  },

  getContentById: {
    END_POINT: 'user/content/:id',
    TYPE: 'GET',
    KEY: 'getContentById',
  },


  // ================= QUESTIONS =================

  addQuestion: {
    END_POINT: 'admin/questions',
    TYPE: 'POST',
    KEY: 'addQuestion',
  },

  updateQuestion: {
    END_POINT: 'admin/questions/:id',
    TYPE: 'PUT',
    KEY: 'updateQuestion',
  },

  deleteQuestion: {
    END_POINT: 'admin/questions/:id',
    TYPE: 'DELETE',
    KEY: 'deleteQuestion',
  },

  getAllQuestions: {
    END_POINT: 'user/questions',
    TYPE: 'GET',
    KEY: 'getAllQuestions',
  },

  getQuestionById: {
    END_POINT: 'user/questions/:id',
    TYPE: 'GET',
    KEY: 'getQuestionById',
  },
  uploadblukQuestions: {
    END_POINT: 'admin/questions/upload-questions',
    TYPE: 'POST',
    KEY: 'uploadBulkQuestions',
  },

  // ================= TEST =================

  createTest: {
    END_POINT: 'admin/test',
    TYPE: 'POST',
    KEY: 'createTest',
  },

  getAllTests: {
    END_POINT: 'user/test',
    TYPE: 'GET',
    KEY: 'getAllTests',
  },

  getTestById: {
    END_POINT: 'user/test/:id',
    TYPE: 'GET',
    KEY: 'getTestById',
  },

  startTest: {
    END_POINT: 'user/test/start',
    TYPE: 'POST',
    KEY: 'startTest',
  },

  saveAnswer: {
    END_POINT: 'user/test/save-answer',
    TYPE: 'POST',
    KEY: 'saveAnswer',
  },

  submitTest: {
    END_POINT: 'user/test/submit',
    TYPE: 'POST',
    KEY: 'submitTest',
  },

  leaderboard: {
    END_POINT: 'user/test/leaderboard/:testId',
    TYPE: 'GET',
    KEY: 'leaderboard',
  },

  myAttempts: {
    END_POINT: 'user/test/my-attempts',
    TYPE: 'GET',
    KEY: 'myAttempts',
  },

  // ================= PREVIOUS YEAR QUESTIONS =================
  getAllPYQ:{
    END_POINT: 'admin/pyq',
    TYPE: 'GET',
    KEY: 'getAllPYQ',
  },

  createPYQ:{
    END_POINT: 'admin/pyq',
    TYPE: 'POST',
    KEY: 'createPYQ',
  },

  updatePYQ:{
    END_POINT: 'admin/pyq/:id',
    TYPE: 'PUT',
    KEY: 'updatePYQ',
  },

  getPYQById:{
    END_POINT: 'admin/pyq/:id',
    TYPE: 'GET',
    KEY: 'getPYQById',
  },

  deletePYQ:{
    END_POINT: 'admin/pyq/:id',
    TYPE: 'DELETE',
    KEY: 'deletePYQ',
  },
  uploadPYQ:{
    END_POINT: 'admin/pyq/upload-pyq',
    TYPE: 'POST',
    KEY: 'uploadPYQ',
  },

  // ================= USER TRACKING =================
getUserRouteHistoryAdmin: {
  END_POINT: "admin/route-history/:userId",
  TYPE: "GET",
  KEY: "getUserRouteHistoryAdmin",
},
searchUsers: {
  END_POINT: "admin/search-users",
  TYPE: "GET",
  KEY: "searchUsers",
},

};